
import { toast } from "react-toastify"
import { fetchConToken } from "../helpers/fetch"

export const initialState = {}

export const Tasks = {

    getAllHome: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`tasks/home/?${params}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    getAll: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`tasks/?${params}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },


    getOne: async (id) => {
        try {

            const resp = await fetchConToken(`tasks/ ${id}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    save: async (data) => {
        try {

            const resp = await fetchConToken('tasks', data, "POST")
            const body = await resp.json();

            if (body.ok) {
                toast.success('datos guardados')
                return body.data.id
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return 0
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    update: async (data) => {
        try {

            const resp = await fetchConToken(`tasks/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return body.data

            } else {

                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    }

}